
export class Phone {
    constructor({
                    //attributes
                    id= null,
                    label= '',
                    phone= '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    ddi = 55
                } = {}) {

        //fill attributes
        this.id=id;
        this.label=label;
        this.phone=phone;
        this.ddi=ddi;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }

}

export function createPhone(data={}) {
    return Object.freeze(new Phone(data));
}